import { ROKT_CDN_URL, ROKT_SERVICE } from './constants';

async function loadRoktSDK(roktTagId, url = ROKT_CDN_URL, serviceName = ROKT_SERVICE) {
  (function (r, o, k, t, n, e, w, a, _) {
    r._ROKT_ = n;
    r[n] = r[n] || {
      id: t,
      h: w,
      lc: [],
      it: new Date(),
      onLoaded: function (c) {
        r[n].lc.push(c);
      },
    };
    a = o.createElement('script');
    a.type = 'text/javascript';
    a.async = !0;
    a.src = k;
    if (e) {
      a.integrity = e;
      a.crossOrigin = 'anonymous';
    }
    _ = o.getElementsByTagName('script')[0];
    _.parentNode.insertBefore(a, _);
  })(window, document, url, roktTagId, serviceName);

  return window.roktService;
}

export default loadRoktSDK;
